import * as actionType from "./action";

export function accountUsersReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_ACCOUNT_USERS_SUCCESS:
      return { ...state, response };
    case actionType.GET_ACCOUNT_USERS_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function accountUserReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_ACCOUNT_USER_SUCCESS:
      return { ...state, response };
    case actionType.GET_ACCOUNT_USER_ERROR:
      return { ...state, response };
    case actionType.ADD_ACCOUNT_USER_SUCCESS:
      return state;
    case actionType.ADD_ACCOUNT_USER_ERROR:
      return { ...state, response };
    case actionType.DELETE_ACCOUNT_USER_SUCCESS:
      return state;
    case actionType.DELETE_ACCOUNT_USER_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}
